import { createContext, useContext } from 'react';
import type { SampleAttachment, SampleBoardItem } from './model';
interface OperationsApi {
  files: SampleAttachment[];
  cards: SampleBoardItem[];
  addFiles: (files: File[], area: 'card' | 'comment', fail: boolean) => void;
  retry: (id: string) => void;
  move: (id: string, columnId: string) => void;
}
export const OperationsContext = createContext<OperationsApi | null>(null);
export function useOperations() {
  const api = useContext(OperationsContext);
  if (!api) throw Error('Нужен OperationsProvider');
  return api;
}
